<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
    post: Object,
    size: Number
})

const isoToDate = (iso) => {
    let date = new Date(iso);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Pads single digits with a '0'
    const dd = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${yyyy}-${mm}-${dd}`;
    return formattedDate;
}

onMounted(async() => {
    //await new Promise(resolve => setTimeout(resolve, 100));
    //if(props.post['post-video'] != null){
    //    document.getElementById('social-video').play()
    //}
})

</script>

<template>
    <div class="content-social-playlist">
        <div class="top-bar">
            <img class="profile-image" v-if = "props.post['profile-image'] != null" :src="props.post['profile-image']">
            <img class="profile-image" v-else src="../../public/assets/imgs/ufc-profile-image.jpg">

            <div class="profile-name">{{ props.post['username'] }}</div>
            <img class="threads-check" src="../../public/assets/imgs/threads-check.png">
            <div class="post-date">{{ isoToDate(props.post['timestamp']) }}</div>
            <img class="threads-icon" src="../../public/assets/imgs/threads-icon.png">
        </div>
        <div class="post-body">
            {{ props.post['text'] }}
        </div>
        <img class="post-image" v-if="true" :src="props.post['image']">
        <video class="post-image" muted=true autoplay=true v-else-if="props.post['mediaType'] == 'VIDEO'"
            :src="props.post['image']"></video>
    </div>
</template>

<style lang="scss" scoped>
@import '../sass/GlobalClasses';
@import '../sass/Settings';
@import '../sass/ToastStyling.scss';

.content-social-playlist {
    $scale: 0.5;

    position: relative;
    font-weight: 400;
    font-size: vw(14*$scale, $glasses-width);
    color: $text-2;
    text-align: left;
    width: 100%;
    padding-bottom: vw(10*$scale, $glasses-width);

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .top-bar {
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .profile-image {
            $size: 56;
            position: relative;
            width: vw($size*$scale, $glasses-width);
            height: vw($size*$scale, $glasses-width);
            border-radius: vw($size*$scale/2, $glasses-width);
        }

        .profile-name {
            $size: 32;
            position: relative;
            font-size: vw($size*$scale, $glasses-width);
            color: $text-0;
            margin-left: vw(16*$scale, $glasses-width);
        }

        .post-date {
            $size: 32;
            position: relative;
            font-size: vw($size*$scale, $glasses-width);
            color: $text-0;
            margin-left: vw(16*$scale, $glasses-width);
        }

        .threads-check {
            $size: 23;
            position: relative;
            width: vw($size*$scale, $glasses-width);
            height: vw($size*$scale, $glasses-width);
            margin-left: vw(16*$scale, $glasses-width);
        }

        .threads-icon {
            $size: 18;
            $sizeh: 21;
            position: relative;
            width: vw($size*$scale, $glasses-width);
            height: vw($sizeh*$scale, $glasses-width);
            justify-self: end;
            margin-left: auto;
            margin-bottom: vw(16*$scale, $glasses-width);
        }
    }

    .post-body {
        margin-top: vw(16*$scale, $glasses-width);
        width: 100%;
        $size: 32;
        position: relative;
        font-size: vw($size*$scale, $glasses-width);
        color: $text-0;
    }

    .post-image {
        $size: 209;
        margin-top: vw(16*$scale, $glasses-width);
        width: vw(209*$scale, $glasses-width);
        border-radius: vw($size*$scale/20, $glasses-width);
        height: auto;
        position: relative;
    }
}

.content-social-toast {
    position: relative;
    font-weight: 700;
    font-size: vw(14);
    color: $text-2;
    text-align: left;
    width: 100%;
    padding-bottom: vw(10);

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .top-bar {
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .profile-image {
            $size: 56;
            position: relative;
            width: vw($size, $glasses-width);
            height: vw($size, $glasses-width);
            border-radius: vw($size/2, $glasses-width);
        }

        .profile-name {
            $size: 32;
            position: relative;
            font-size: vw($size, $glasses-width);
            color: $text-0;
        }

        .post-date {
            $size: 32;
            position: relative;
            font-size: vw($size, $glasses-width);
            color: $text-0;
        }

        .threads-check {
            $size: 23;
            position: relative;
            width: vw($size, $glasses-width);
            height: vw($size, $glasses-width);
        }

        .threads-icon {
            $size: 18;
            $sizeh: 21;
            position: relative;
            width: vw($size, $glasses-width);
            height: vw($sizeh, $glasses-width);
        }
    }

    .post-body {
        width: 100%;
        $size: 32;
        position: relative;
        font-size: vw($size, $glasses-width);
        color: $text-0;
    }

    .post-image {
        $size: 209;
        width: vw(209, $glasses-width);
        border-radius: vw($size/20, $glasses-width);
        height: auto;
        position: relative;
    }
}
</style>
